import { useMemo, useState, useEffect } from 'react';
import { useMutation } from 'react-query';
import { getGatekeeperApiClient } from 'lib/SplashApiClient/subclients/GatekeeperApiClient';
import { useOnGatekeeperRequestError } from './useOnGatekeeperRequestError';
import { GATEKEEPER_STATES } from '../constants';

export const useGetHeartbeatId = ({ enabled, guestId, eventId, guestAccessHash }) => {
    const [gateStatus, setGateStatus] = useState(GATEKEEPER_STATES.NOT_INITIALIZED);
    const [heartbeatId, setHeartbeatId] = useState(null);
    const [timeToLeave, setTimeToLeave] = useState(null);

    const gatekeeperApiClient = useMemo(() => getGatekeeperApiClient({ guestAccessHash }), [guestAccessHash]);
    const fetchHeartbeatIdMutation = useMutation(() => gatekeeperApiClient.getHeartbeatId({ guestId, eventId }));

    useEffect(() => {
        if (enabled) {
            fetchHeartbeatIdMutation.mutate({ guestId, eventId });
        }
    }, [enabled]);

    useOnGatekeeperRequestError({
        statusCode: fetchHeartbeatIdMutation?.error?.status,
        onGatesClosed: () => setGateStatus(GATEKEEPER_STATES.CLOSED),
        onGatesOpened: () => setGateStatus(GATEKEEPER_STATES.OPENED),
    });

    useEffect(() => {
        const id = fetchHeartbeatIdMutation?.data?.id;
        const ttl = fetchHeartbeatIdMutation?.data?.ttl;

        id && setHeartbeatId(id);
        ttl && setTimeToLeave(ttl);
    }, [fetchHeartbeatIdMutation?.data?.id]);

    useEffect(() => {
        if (heartbeatId) {
            setGateStatus(GATEKEEPER_STATES.OPENED);
        }
    }, [heartbeatId]);

    return { heartbeatId, heartbeatGateStatus: gateStatus, timeToLeave };
};
